import { render, staticRenderFns } from "./UserControlHeaderContent.vue?vue&type=template&id=f1647ae8&"
import script from "./UserControlHeaderContent.vue?vue&type=script&lang=ts&"
export * from "./UserControlHeaderContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports